{
  "name": "test-front-rob",
  "version": "24.0.3",
  "scripts": {
    "ng": "ng",
    "start": "node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng serve --proxy-config proxy.conf.json",
    "startHeap": "ng serve --proxy-config proxy.conf.json --aot",
    "serve-onpremise": "node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng serve --proxy-config proxy.conf.json --configuration=onpremise",
    "serve": "node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng serve --proxy-config proxy.conf.json",
    "build-onpremise": "npm run version-build && ng build --configuration=onpremise",
    "build": "npm run version-build && ng build",
    "shipituat": "shipit robUat",
    "deploy-major": "npm version major && git tag $npm_package_version && git push --tags && shipit rob",
    "deploy-minor": "npm version minor && git tag $npm_package_version && git push --tags && shipit rob",
    "deploy-patch": "npm version patch && git tag $npm_package_version && git push --tags && shipit rob",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "build-prod": "npm run version-build && node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng build --configuration=production --aot --stats-json && npm run purge-css",
    "sentry": "&& npm run sentry:sourcemaps",
    "build-uat": "npm run version-build -- --demo && node --max_old_space_size=10000 ./node_modules/@angular/cli/bin/ng build --aot --stats-json",
    "purge-css": "purgecss --css dist/test-front-rob/browser/*.css --content 'dist/test-front-rob/browser/**/*.html' 'dist/test-front-rob/browser/**/*.js' --output dist/test-front-rob/browser",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "version-build": "node scripts/generate-version.js",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org bam-archi --project aglo-front ./dist && sentry-cli sourcemaps upload --org bam-archi --project aglo-front ./dist"
  },
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.2.4",
    "@angular/cdk": "19.2.4",
    "@angular/common": "19.2.4",
    "@angular/compiler": "19.2.4",
    "@angular/core": "19.2.4",
    "@angular/forms": "19.2.4",
    "@angular/material": "19.2.4",
    "@angular/platform-browser": "19.2.4",
    "@angular/platform-browser-dynamic": "19.2.4",
    "@angular/router": "19.2.4",
    "@igniteui/material-icons-extended": "^2.10.0",
    "@ngrx/effects": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@ngrx/store-devtools": "^19.0.1",
    "@pdfme/common": "^5.4.2",
    "@pdfme/generator": "^5.4.2",
    "@pdfme/schemas": "^5.4.2",
    "@pdfme/ui": "^5.4.2",
    "@pdftron/webviewer": "^11.8.0",
    "@primeng/themes": "^19.0.10",
    "@sentry/angular": "^9.34.0",
    "@sentry/cli": "^2.46.0",
    "@zumer/snapdom": "^2.24.15",
    "angular-confirmation-popover": "^7.0.0",
    "angular2-notifications": "^16.0.1",
    "aws-sdk": "^2.1398.0",
    "bluebird": "^3.5.1",
    "bootstrap": "^3.4.1",
    "chart.js": "^3.7.1",
    "client-zip": "^2.3.0",
    "core-js": "^2.4.1",
    "docx": "7.8.2",
    "dom-autoscroller": "^2.3.4",
    "dot-prop-immutable": "^2.1.0",
    "dragula": "^3.7.3",
    "exceljs": "4.4.0",
    "fflate": "^0.7.3",
    "file-saver": "^2.0.2",
    "font-awesome": "^4.7.0",
    "googlemaps": "^1.12.0",
    "hammerjs": "^2.0.8",
    "helphero": "^2.5.0",
    "html2json4wx": "^1.0.5",
    "https-browserify": "^1.0.0",
    "intl": "^1.2.5",
    "jquery": "^3.5.1",
    "jszip": "^3.9.1",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "martinez-polygon-clipping": "^0.8.1",
    "minireset.css": "~0.0.4",
    "ng2-dragula": "^6.0.0",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-color": "^7.0.0",
    "ngx-cookie-service": "19.1.2",
    "ngx-csv-parser": "1.3.1",
    "ngx-pagination": "^6.0.3",
    "ngx-quill": "^28.0.1",
    "ngx-textarea-autosize": "^2.0.3",
    "only": "0.0.2",
    "os-browserify": "^0.3.0",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^5.4.449",
    "pdfmake": "^0.1.37",
    "pixi-viewport": "^6.0.3",
    "pixi.js": "^8.14.3",
    "posthog-js": "^1.438.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "19.0.7",
    "quill": "^2.0.3",
    "quill-better-table": "^1.2.10",
    "quill-blot-formatter": "^1.0.5",
    "quill-table-better": "^1.2.2",
    "rxjs": "^6.5.5",
    "rxjs-compat": "^6.5.5",
    "stream-browserify": "^3.0.0",
    "stream-http": "^3.2.0",
    "tslib": "^1.10.0",
    "uploadcare-widget": "^3.0.1",
    "xml-js": "^1.6.11",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.5",
    "@angular/cli": "^19.2.5",
    "@angular/compiler-cli": "19.2.4",
    "@angular/language-service": "19.2.4",
    "@compodoc/compodoc": "^1.1.26",
    "@ngrx/schematics": "^19.0.1",
    "@types/hammerjs": "^2.0.40",
    "@types/jasmine": "~3.5.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/jquery": "^3.3.38",
    "@types/node": "^12.12.39",
    "@typescript-eslint/eslint-plugin": "^8.29.0",
    "@typescript-eslint/parser": "^8.29.0",
    "ajv": "^7.2.4",
    "assert": "^2.1.0",
    "crypto": "^1.0.1",
    "crypto-browserify": "^3.12.0",
    "dotenv-webpack": "^8.0.1",
    "eslint": "^9.23.0",
    "eslint-plugin-unused-imports": "^4.1.4",
    "glob": "^10.4.5",
    "jasmine-spec-reporter": "~4.2.1",
    "karma": "~6.3.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~2.1.0",
    "karma-jasmine": "~3.0.1",
    "karma-jasmine-html-reporter": "^1.4.2",
    "net": "^1.0.2",
    "path": "^0.12.7",
    "path-browserify": "^1.0.1",
    "process": "^0.11.10",
    "protractor": "~7.0.0",
    "purgecss": "^7.0.2",
    "shipit-cli": "^5.3.0",
    "shipit-deploy": "^5.3.0",
    "stream": "^0.0.2",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.5.4"
  },
  "bundleDependencies": [
    "@angular/animations",
    "@angular/cdk",
    "@angular/common",
    "@angular/compiler",
    "@angular/core",
    "@angular/forms",
    "@angular/material",
    "@angular/platform-browser",
    "@angular/platform-browser-dynamic",
    "@angular/router",
    "@igniteui/material-icons-extended",
    "@ngrx/effects",
    "@ngrx/store",
    "@ngrx/store-devtools",
    "angular-confirmation-popover",
    "angular2-notifications",
    "aws-sdk",
    "bluebird",
    "bootstrap",
    "chart.js",
    "client-zip",
    "core-js",
    "dom-autoscroller",
    "dot-prop-immutable",
    "fflate",
    "file-saver",
    "font-awesome",
    "googlemaps",
    "hammerjs",
    "helphero",
    "html2json4wx",
    "https-browserify",
    "intl",
    "jquery",
    "jszip",
    "lodash",
    "minireset.css",
    "ng2-dragula",
    "ngx-color",
    "ngx-cookie-service",
    "ngx-csv-parser",
    "ngx-pagination",
    "ngx-textarea-autosize",
    "only",
    "os-browserify",
    "pdfmake",
    "primeicons",
    "primeng",
    "quill",
    "quill-blot-formatter",
    "rxjs",
    "rxjs-compat",
    "stream-browserify",
    "stream-http",
    "tslib",
    "uploadcare-widget",
    "xml-js",
    "zone.js"
  ],
  "overrides": {}
}
